"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubstrateNotCompatibleWithRefinementsRule = void 0;
var Glossary_1 = require("../../helpers/Glossary");
var SubstrateNotCompatibleRule_1 = require("./SubstrateNotCompatibleRule");
var SubstrateNotCompatibleWithRefinementsRule = /** @class */ (function (_super) {
    __extends(SubstrateNotCompatibleWithRefinementsRule, _super);
    function SubstrateNotCompatibleWithRefinementsRule() {
        var _this = _super.call(this) || this;
        _this.incompatibleSubstrates = [];
        _this.optionNoneSelected = Glossary_1.Glossary.NO_REFINEMENT_SKU;
        _this.messageSelector = '.paper-select .js-substrate-refinement-incompatibility';
        _this.disabledClass = 'is-disabled-because-refinement';
        _this.incompatibleSubstrates = [
            '[data-paper=P02]',
            '[data-paper=P03]',
            '[data-paper=P14]',
            '[data-paper=P18]',
            '[data-paper=P50]',
        ];
        _this.firstFallbackSubstrate = '[data-paper=P01]';
        _this.secondFallbackSubstrate = '[data-paper=P08]';
        return _this;
    }
    return SubstrateNotCompatibleWithRefinementsRule;
}(SubstrateNotCompatibleRule_1.SubstrateNotCompatibleRule));
exports.SubstrateNotCompatibleWithRefinementsRule = SubstrateNotCompatibleWithRefinementsRule;
